import { render } from "./CustomColorMultiselect.vue?vue&type=template&id=2aa5bafb&scoped=true"
import script from "./CustomColorMultiselect.vue?vue&type=script&lang=js"
export * from "./CustomColorMultiselect.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CustomColorMultiselect.vue?vue&type=style&index=1&id=2aa5bafb&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa5bafb"]])

export default __exports__